export const cookieModal = {
  name: 'promo-modal',
  value: 'seen',
};

export const stages = {
  Initial: 'Initial',
  Success: 'Success',
  Invalid: 'Invalid',
  Close: 'Close',
};

export const errorMsg = 'Please enter a valid email address.';
export const existingCustomerWithOrders = 'existing_customer_with_orders';



/** WEBPACK FOOTER **
 ** ./apps/emailPromoModal/lib/constants.js
 **/